import { Button, Checkbox, Input, Radio } from 'antd';
import './index.less';
import { useEffect, useState, useRef, useContext } from 'react';
import CryptoJS from 'crypto-js';
import { ReactComponent as CheckSvg } from './icons/check.svg';
import { ReactComponent as CheckedSvg } from './icons/checked.svg';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as TnSvg } from './icons/tn.svg';
import { ReactComponent as UserSvg } from './icons/user.svg';
import { ReactComponent as PwdSvg } from './icons/pwd.svg';
import form from 'antd/es/form';
import { SystemContext } from '@/App';
import { SystemStatus } from '@/commons/context/system-store';
import TnMessage from '@/commons/widget/message';
import { getUserByLogin } from '@/api/project/user';
import { User } from '@/commons/interface/project/user';
import localStore, { REMEMBER_PASSWORD, REMEMBER_TAG, REMEMBER_USERNAME, USER_META } from '@/commons/store/local-store';


interface IProps {

}

export default function LoginMain(props: IProps) {
    const navigate = useNavigate();
    const [username, setUsername] = useState<string>(""); // 用户名
    const [password, setPassword] = useState<string>(""); // 密码
    const [remember, setRemember] = useState<boolean>(false); // 记住我
    const [loading, setLoading] = useState<boolean>(false); // loading
    const systemContext = useContext<SystemStatus>(SystemContext);

    useEffect(() => {
        if (!!localStore.userUuid) {
            // 已经登录，跳转到项目列表页
            navigate("/desktop/project-list");
            return;
        }
        // 从本地存储中获取自动保存的账户信息
        let username = localStore.get(REMEMBER_USERNAME);
        let remember = localStore.get(REMEMBER_TAG);
        let password = localStore.get(REMEMBER_PASSWORD) || '';
        setUsername(username);
        setRemember(remember);
        setPassword(CryptoJS.enc.Base64.parse(password).toString(CryptoJS.enc.Utf8));
    }, [])

    const login = () => {
        if (!username) {
            TnMessage.warning("用户名不能为空");
            return;
        }
        if (!password) {
            TnMessage.warning("密码不能为空");
            return;
        }
        setLoading(true);
        let md5Password = CryptoJS.MD5(password).toString();
        getUserByLogin(username, md5Password).then(res => {
            if (res.status === 200) {
                let user: User = res.data;
                TnMessage.success("登录成功");
                if (remember) {
                    localStore.set(REMEMBER_USERNAME, username);
                    localStore.set(REMEMBER_PASSWORD, CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(password)));
                    localStore.set(REMEMBER_TAG, remember);
                } else {
                    localStore.remove(REMEMBER_USERNAME);
                    localStore.remove(REMEMBER_PASSWORD);
                    localStore.remove(REMEMBER_TAG);
                }
                localStore.token = user.token;
                localStore.userUuid = user.uuid;
                localStore.setUser(user);
                navigate("/desktop/project-list");
            }
        }).catch(err => {
            TnMessage.error(err.data || '登录失败');
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <div className='login-container'>
            {/* <div className='tn-logo'><TnSvg /></div> */}
            {/* <div className='ellipse-1'></div> */}
            {/* <div className='ellipse-2'></div> */}
            <div className="big-bg"></div>
            <div className="login-panel">
                <Input
                    style={{ marginBottom: 16 }}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    prefix={<UserSvg />}
                    placeholder='请输入用户名'
                />
                <Input
                    style={{ marginBottom: 16 }}
                    type='password'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    prefix={<PwdSvg />}
                    placeholder='请输入密码'
                    onPressEnter={login}
                />
                <div className='remeber-me' onClick={() => setRemember(pre => !pre)}>
                    {!remember && <CheckSvg />}
                    {remember && <CheckedSvg />}
                    记住我
                </div>
                <Button onClick={login} loading={loading}>登录</Button>
            </div>
        </div >
    )
}